import { render, staticRenderFns } from "./OriginalExam.vue?vue&type=template&id=54073e7e&scoped=true&"
import script from "./OriginalExam.vue?vue&type=script&lang=js&"
export * from "./OriginalExam.vue?vue&type=script&lang=js&"
import style0 from "./OriginalExam.vue?vue&type=style&index=0&id=54073e7e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54073e7e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
